/* eslint-disable hooks/sort */
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import Button from "@aleaplay/web-components/ui/Button";
import DropdownList from "@aleaplay/web-components/ui/DropdownList";

import { ChevronIcon, LocaleSelectorIcon } from "@/v1/components/atoms/Icons";
import { changeLocale } from "@/v1/store/app/actions";
import { useIsInIframe } from "@/v2/hooks/useIsInIframe";

import "./localeSelector.scss";

const LocaleSelector = () => {
  const isInIframe = useIsInIframe();
  const dispatch = useDispatch();
  const locale = useSelector((state: any) => state.app.locale);
  const [visible, setVisibility] = useState(false);
  const [langSelected, setLangSelected] = useState(locale);

  const onChangeLang = (lang: string) => {
    changeLocale(lang)(dispatch);
    setLangSelected(lang);
  };

  if (isInIframe) return null;

  return (
    <DropdownList
      place="right"
      visible={visible}
      selectable
      type="single"
      onClickOverlay={() => setVisibility(false)}
    >
      <DropdownList.Header>
        <FormattedMessage id="label.select-your-language" />
      </DropdownList.Header>
      <DropdownList.Trigger>
        <Button
          className="ui-locale-selector__button"
          modifier="secondary"
          onClick={() => setVisibility(!visible)}
        >
          <LocaleSelectorIcon width={18} height={18} />
          <FormattedMessage id="label.language" />
          <ChevronIcon className="ui-locale-selector__chevron-icon" />
        </Button>
      </DropdownList.Trigger>
      <DropdownList.List>
        <DropdownList.Item
          key="en-GB"
          id="en-GB"
          active={langSelected === "en-GB"}
          onChange={() => onChangeLang("en-GB")}
        >
          English
        </DropdownList.Item>
        <DropdownList.Item
          key="es-ES"
          id="es-ES"
          active={langSelected === "es-ES"}
          onChange={() => onChangeLang("es-ES")}
        >
          Spanish
        </DropdownList.Item>
      </DropdownList.List>
    </DropdownList>
  );
};

export default LocaleSelector;
